import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { whatsappLink, brand } from '../data/mock';

const WhatsAppFab = () => {
  const [openChat, setOpenChat] = useState(false);
  const [showLabel, setShowLabel] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowLabel(true), 1800);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {openChat && (
        <div className="w-[300px] rounded-2xl bg-[#171311] border border-cream/10 shadow-2xl overflow-hidden fade-up">
          <div className="flex items-center justify-between p-4 bg-[#1f1a17]">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center">
                <svg viewBox="0 0 32 32" className="w-5 h-5 text-white" fill="currentColor">
                  <path d="M16.06 5.62c-5.77 0-10.45 4.68-10.45 10.45 0 1.84.49 3.64 1.41 5.22L5.61 26.4l5.27-1.39a10.47 10.47 0 0 0 5.18 1.32h.01c5.77 0 10.45-4.68 10.45-10.45 0-2.79-1.09-5.42-3.06-7.39a10.39 10.39 0 0 0-7.4-3.07Z" />
                </svg>
              </div>
              <div>
                <p className="text-cream text-[13px] font-medium leading-tight">{brand.full}</p>
                <p className="text-cream/60 text-[11px]">Online agora</p>
              </div>
            </div>
            <button onClick={() => setOpenChat(false)} className="text-cream/70 hover:text-cream" aria-label="Fechar">
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="p-4 space-y-3">
            <div className="bg-[#0b0807] rounded-lg p-3 text-[13px] text-cream-soft leading-relaxed">
              <span className="text-cream">Olá!</span> Boas-vindas à <strong className="text-cream">BRN Barbearia</strong>
              <p className="mt-1">Podemos te ajudar?</p>
            </div>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="block w-full text-center rounded-full bg-[#25D366] text-white py-2.5 text-[13px] font-medium hover:brightness-110 transition"
            >
              Abrir bate-papo
            </a>
          </div>
        </div>
      )}

      <div className="flex items-center gap-3">
        {showLabel && !openChat && (
          <button
            onClick={() => setOpenChat(true)}
            className="bg-cream text-[#0b0807] text-[12.5px] font-medium px-4 py-2 rounded-full shadow-lg hover:bg-white transition"
          >
            Fale conosco!
          </button>
        )}
        <button
          onClick={() => setOpenChat(!openChat)}
          className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl hover:brightness-110 transition"
          aria-label="WhatsApp"
        >
          <svg viewBox="0 0 32 32" className="w-7 h-7" fill="currentColor">
            <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.4-.545-.484-1.064-1.077-1.483-1.65-.099-.141-.297-.371-.297-.552 0-.342.84-.94.84-1.302 0-.139-.073-.279-.149-.402-.181-.302-.359-.617-.546-.917-.165-.265-.315-.595-.49-.815-.116-.146-.219-.319-.488-.319h-.524c-.165 0-.265.024-.39.08-.391.176-.722.512-.856.95-.117.39-.139.812-.13 1.215.014.582.119 1.149.314 1.683.244.667.609 1.296 1.005 1.892.668 1.005 1.493 1.917 2.428 2.7 1.198 1.001 2.586 1.751 4.034 2.198.532.166 1.085.295 1.65.34.507.04 1.04 0 1.555-.07.534-.071 1.073-.243 1.523-.586.451-.342.851-.789 1.137-1.281.181-.31.319-.665.379-1.024.04-.244.022-.515-.026-.727-.058-.255-.218-.435-.4-.594-.376-.328-.831-.583-1.246-.842-.215-.135-.443-.27-.665-.392-.196-.108-.42-.232-.638-.234h-.062Zm-3.046 8.15a8.918 8.918 0 0 1-3.927-.95l-2.74.873.875-2.7a9.025 9.025 0 0 1-1.06-4.247c-.005-4.953 4.027-8.985 8.989-8.985 2.4.002 4.65.937 6.345 2.633a8.917 8.917 0 0 1 2.633 6.341c-.005 4.952-4.038 8.985-9.115 8.985Zm0-19.732C9.81 5.623 4.652 10.78 4.65 17.118c0 1.847.481 3.652 1.4 5.244L4.567 28l5.794-1.516a11.479 11.479 0 0 0 5.696 1.45h.005c6.247 0 11.4-5.157 11.405-11.495 0-3.054-1.18-5.93-3.343-8.097a11.367 11.367 0 0 0-8.06-3.342" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default WhatsAppFab;
